import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Layout } from '@/components/Layout';
import { Login } from '@/pages/Login';
import { ChangePassword } from '@/pages/ChangePassword';
import { Dashboard } from '@/pages/Dashboard';
import { ClientSettings } from '@/pages/ClientSettings';
import { UsersAndStores } from '@/pages/UsersAndStores';
import { UserChats } from '@/pages/UserChats';
import { ServicesStatus } from '@/pages/ServicesStatus';
import { Subscriptions } from '@/pages/Subscriptions';
import { Admins } from '@/pages/Admins';
import { AdminCabinetUrlProvider } from '@/context/AdminCabinetUrlContext';

function ChangePasswordOrRedirect() {
  return <ChangePassword />;
}

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function MustChangePasswordGate({ children }: { children: React.ReactNode }) {
  const { admin } = useAuth();
  if (admin?.mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/change-password"
        element={
          <ProtectedRoute>
            <ChangePasswordOrRedirect />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MustChangePasswordGate>
              <AdminCabinetUrlProvider>
                <Layout />
              </AdminCabinetUrlProvider>
            </MustChangePasswordGate>
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="client-settings" element={<ClientSettings />} />
        <Route path="users" element={<UsersAndStores />} />
        <Route path="chats" element={<UserChats />} />
        <Route path="services" element={<ServicesStatus />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="admins" element={<Admins />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
